/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint-disable-next-line max-len */
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state", "payload"] }] */

import api from '../../utils/api';

const baseURL = process.env.VUE_APP_BASE_URI;
const imageDir = '/images/marketing/';


const state = {
  articles: [],
  article: {},
  imageDir: baseURL + imageDir,
  loading: false,
  errorMessage: '',
};


const getters = {};


const mutations = {
  setArticles(state, articles) {
    state.articles = articles;
  },
  setArticle(state, article) {
    state.article = article;
  },
  setLoading(state, { loading }) {
    state.loading = loading;
  },
  setErrorMessage(state, error) {
    state.errorMessage = error;
  },
};


const actions = {
  getAllArticles({ commit }) {
    commit('setLoading', { loading: true });
    api
      .getData('/articles/')
      .then((res) => {
        const articles = res.data;
        commit('setArticles', articles);
        commit('setLoading', { loading: false });
      })
      .catch((error) => {
        commit('setLoading', { loading: false });
        commit('setErrorMessage', error);
      });
  },
  getArticleBySlug({ commit }, slug) {
    return new Promise((resolve, reject) => {
      commit('setLoading', { loading: true });
      api
        .getData(`/articles/${slug}`)
        .then((res) => {
          const article = res.data;
          commit('setArticle', article);
          commit('setLoading', { loading: false });
          resolve();
        })
        .catch((error) => {
          commit('setLoading', { loading: false });
          commit('setErrorMessage', error);
          reject();
        });
    });
  },
};


export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
